import { render, staticRenderFns } from "./MeterPrices.vue?vue&type=template&id=88bf1ee0&scoped=true&"
import script from "./MeterPrices.vue?vue&type=script&lang=js&"
export * from "./MeterPrices.vue?vue&type=script&lang=js&"
import style0 from "./MeterPrices.vue?vue&type=style&index=0&id=88bf1ee0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88bf1ee0",
  null
  
)

export default component.exports